import { getSessionStoreKey as e } from "@systemeio/util";
import { useLocalStorage as t } from "../../../node_modules/usehooks-ts/dist/index.mjs";
const f = () => {
  const [o, s] = t(e("ai-chat-open"), !1), [n, r] = t(e("ai-chat-chat-open"), !0), [a, c] = t(
    e("ai-chat-history-open"),
    !1
  ), [p, i] = t(
    e("ai-chat-fullscreen"),
    !1
  );
  return {
    open: o,
    setOpen: s,
    chatOpen: n,
    setChatOpen: r,
    historyOpen: a,
    setHistoryOpen: c,
    fullScreen: p,
    setFullScreen: i
  };
};
export {
  f as useWidgetControls
};
